<template>
  <div class="exhibitor-choice">
    <div class="exhibitor-card" v-for="exhibitor in exhibitorList" :key="exhibitor.id" @click="toDetail(exhibitor)">
      <div class="title ellipsis-2">{{exhibitor.title}}</div>
      <div class="time">{{ exhibitor.createTime | filterDateUnix}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        exhibitorList: []
      }
    },
    mounted() {
      this.initData()
      this.getFigures()
    },
    methods: {
      initData() {
        // 北京
        if (this.$route.query.exhibitionId === "b748b21f7e8a444ea3e8534cb8c4a778") {
          this.$store.commit('changeToken', 'PBB+hfqyCn5u/Asp+KqEarBtK16fcEUvFkwWLg/qYsrGqTTtK0xlBOZ/bJUKrMMzof8sLu5r3r63PvppDkGkiLzG85oLAEQsMP5d7VZwTCWbvhcKPNNmsMLdJF1pRAw38/lzo80KxYaPNqn7kEkK/4ao8PtJntusCKMogpLx0vE9LVeWjibuKd5JM0nnYrX+4OPLBORXcSObUSWY1pPTLHzhxLGBP9tOeJdS6oZ4RYKXIeoSHtEZefeF/0Ne5PpFdZjPGeTCeSLhi0QVNZ+70jSDR0ZiOfQJ5NTNtnT9EOJMGGPZkoevYDS/Wd1LcvI5xPT8hle8hE3TgEdYGc2Z+P4TQ3pEta1RRke+boQK/qNYu1LJkzJtNYIDRsf1bshJFAf5AxjrLvNiDx1pKcwNfgT1w5M/Dvv5yMKwTbI5yGQ=')
        } else {
          this.$store.commit('changeToken', 'PBB+hfqyCn5u/Asp+KqEamW0Vx7NksypKe3cJLRObbLGqTTtK0xlBOZ/bJUKrMMzof8sLu5r3r63PvppDkGkiLzG85oLAEQsMP5d7VZwTCWbvhcKPNNmsMLdJF1pRAw38/lzo80KxYaPNqn7kEkK/5l55e1l36aMZZt8kt8Y7YtXpcYaoaO4fmuQr0nSEXBVodqnXTZJTWQ+rIPGfgpNDnzhxLGBP9tOeJdS6oZ4RYKXIeoSHtEZefeF/0Ne5PpFdZjPGeTCeSLhi0QVNZ+70jSDR0ZiOfQJ5NTNtnT9EOJMGGPZkoevYDS/Wd1LcvI5xPT8hle8hE3TgEdYGc2Z+P4TQ3pEta1RRke+boQK/qNYu1LJkzJtNYIDRsf1bshJFAf5AxjrLvNiDx1pKcwNfgT1w5M/Dvv5yMKwTbI5yGQ=')
        }
      },
      getFigures() {
        const params = {
          exhibitionId: this.$route.query.exhibitionId || 'eebca7026d394626a41e95f923e94722', // 默认上海展
          appId: '3845fc7a56be4929a8fd367098c38b0f',
          languageType: 'cn',
          subjectType: 'VISITOR',
          sourceType: 2
        }
        this.$http.getFigures(params).then(res => {
          if (res.code === 1000) {
            const bannerMap = res.data.bannerMap
            this.exhibitorList = bannerMap.LOCALSTYLE
          }
        })
      },
      toDetail(exhibitor) {
        if (exhibitor.urlType === "INTERH5") {
          if (exhibitor.url) {
            if (/\.pdf$/i.test(exhibitor.url)) {
              window.open(exhibitor.url)
            } else {
              window.location.href = exhibitor.url
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.exhibitor-choice {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
  .exhibitor-card {
    padding: 16px 12px;
    border-radius: 5px;
    background: #ffffff;
    margin-bottom: 12px;
    .title {
      font-weight: 700;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
      margin-bottom: 12px;
    }
    .content {
      height: 50px;
      display: flex;
      flex-direction: row-reverse;
      .logo {
        width: 50px;
        height: 50px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
    .time {
      font-weight: 400;
      font-size: 10px;
      color: rgba(0, 0, 0, 0.35);
    }
  }
}
</style>